module.exports = __webpack_public_path__ + "media/images/element/profit-2a118afe981235dd721c90cf0e76dbe9.svg";